<template>
  <div class="table-responsive">
    <table class="table border">
      <thead role="rowgroup">
        <tr role="row">
          <th class="" :key="index" v-for="(field, index) in fields">
            {{ field }}
          </th>
        </tr>
      </thead>
      <tbody role="rowgroup">
        <tr
          role="row"
          v-for="item in generateItems"
          :key="item.id"
          class="font-weight-bold"
          :class="
            pathOr(0, ['level'], item) % 2 ? 'text-warning' : 'text-primary'
          "
        >
          <td v-if="item.loading" colspan="5">
            <LoadingSpinner
              :loading="item.loading"
              :text="$lang.updating_data"
              bg="bg-secondary"
            />
          </td>
          <td
            v-if="!item.loading"
            class="align-middle font-weight-bold"
            :class="
              pathOr(0, ['level'], item) % 2 ? 'text-warning' : 'text-primary'
            "
          >
            {{ "&nbsp;".repeat(pathOr(0, ["level"], item) * 4) }}{{ item.name }}
          </td>
          <td
            v-show="!item.loading"
            class="td-checkbox-role"
            v-for="permission in item.permissions"
            :key="permission.id"
          >
            <b-form-checkbox
              v-if="permission.enable"
              :checked="permission.assigned"
              v-b-tooltip.hover
              :title="permission.caption"
              @change="change($event, item.permissions, permission, item)"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <Confirm
      :title="'تغییر سطح دسترسی'"
      :description="confirmMessage"
      v-model="confirmModel"
      :ok-title="$lang.azmoonLang.yes"
      :cancel-title="$lang.azmoonLang.no"
      @ok="okConfirm"
      @cancel="cancelConfirm"
    >
      <template slot="extra-area">
        <div class="d-flex align-items-center mt-3">
          <input type="checkbox" v-model="acceptConfirm" /><strong
            v-text="$lang.acceptConfirmText"
            class="ml-1"
          />
        </div>
      </template>
    </Confirm>
  </div>
</template>

<script>
import Confirm from "@/components/base/confirm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { generateApiUrl } from "@/shared/utils";
import { pathOr } from "ramda";

export default {
  name: "table-role",
  components: {
    Confirm,
    LoadingSpinner,
  },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    roleCode: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      confirmModel: false,
      generateItems: [],
      currentItem: null,
      currentPermissionId: null,
      acceptConfirm: false,
    };
  },
  computed: {
    confirmMessage() {
      return `با حذف یا کاهش دسترسی این نقش دسترسی کلیه نقش‌های زیر مجموعه حذف خواهد شد.
      <br>
      آیا برای تغییر سطح دسترسی مطمئن هستید ؟
      `;
    },
  },
  watch: {
    acceptConfirm(value) {
      value && localStorage.setItem("accept-confirm-role", value);
    },
  },
  created() {
    /* guidance: add id and loading keys to items */
    this.generateItems = this.items.map((item, index) => {
      return { ...item, id: index + 1, loading: false };
    });
  },
  destroyed() {
    localStorage.removeItem("accept-confirm-role");
  },
  methods: {
    pathOr,
    generateApiUrl,
    change(event, permissions, permission, item) {
      const beforeIndex =
        permissions
          .map((item, index) => {
            if (item.assigned) return index;
          })
          .filter(Boolean)[0] || 0;

      permissions.map((x) => {
        x.assigned = !!(permission.id === x.id && event === true);
      });
      const afterIndex =
        permissions
          .map((item, index) => {
            if (item.assigned) return index;
          })
          .filter(Boolean)[0] || 0;

      const uncheckedAll = permissions.every((item) => !item.assigned);
      const permission_id = pathOr(null, ["id"], permission);

      if (uncheckedAll || afterIndex < beforeIndex) {
        this.currentItem = { ...item };
        this.currentPermissionId = permission_id;

        const hasAcceptConfirm =
          localStorage.getItem("accept-confirm-role") || false;
        if (!hasAcceptConfirm) {
          this.confirmModel = true;
          return;
        }
      }
      this.assignRolePermission(item, permission_id);
    },
    cancelConfirm() {
      this.confirmModel = false;
      this.currentItem = null;
    },
    okConfirm() {
      this.assignRolePermission(this.currentItem, this.currentPermissionId);
    },
    fetchData() {
      this.$emit("fetchData");
    },
    setGenerateItems(obj) {
      /* guidance: replace values of items */
      this.generateItems = this.generateItems.map((item) => {
        return item.id === obj.id ? { ...item, ...obj } : item;
      });
    },
    async assignRolePermission(item, permissionId) {
      this.cancelConfirm();
      try {
        this.setGenerateItems({ ...item, loading: true });
        const roleCode = pathOr(this.roleCode, ["role", "code"], item);
        const url = generateApiUrl(
          ["profile", "assign_role_permission"],
          [roleCode, permissionId]
        );
        const response = await this.$httpService.put(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);

        /* guidance: checked the get value of service in permissions */
        const id = pathOr(null, ["response", "data", "data"], error);
        this.restorePermissionChecked(id);
      } finally {
        this.setGenerateItems({ ...item, loading: false });
        this.fetchData();
      }
    },
    restorePermissionChecked(item, value) {
      item.permissions = item.permissions.map((permission) => {
        return {
          ...permission,
          assigned: permission.id === value,
        };
      });
    },
    restoreAclChecked(item, value) {
      item.acl_role = value;
      item.permissions = item.permissions.map((permission) => {
        return {
          ...permission,
          acl_role: value,
        };
      });
    },
  },
};
</script>
<style scoped>
.table thead th {
  text-align: right; /* center checkbox horizontally */
  vertical-align: middle; /* center checkbox vertically */
  outline: 0;
}
.table th,
.table td {
  text-align: right; /* center checkbox horizontally */
  vertical-align: middle; /* center checkbox vertically */
  outline: 0;
}
</style>
